
import { Component, Vue } from 'vue-property-decorator'
import Logo from "@/components/Logo/index.vue"
import store from '@/store'
import { ApplicationClaimType } from '@/api-client'
import { filterTenantDisplay } from "@/utils/tenantHelpers";

@Component({
  name: 'ProductFinder',
  components: {
    Logo
  },
})
export default class extends Vue {
  products: {src: string, alt: string, url: string, tenantExclude?: Array<string>}[] = [
    {
      src: "gud_logo.png",
      alt: "GUD",
      url: "https://www.gud.co.za/filter-finder/"
    },
    {
      src: "fram_logo.jpg",
      alt: "Fram",
      url: "https://www.fram.co.za/parts-search/",
      tenantExclude: ["ZWE"]
    },
    {
      src: "holts_logo.jpg",
      alt: "Holts",
      url: "https://holtssa.co.za/"
    },
    {
      src: "indyoil_logo.png",
      alt: "IndyOil",
      url: "http://www.indyoil.co.za"
    },
    {
      src: "powerdown_logo.png",
      alt: "Powerdown",
      url: "https://powerdown.co.za/"
    },
    {
      src: "raw_logo.png",
      alt: "RAW 4x4",
      url: "https://raw4x4.co.za/"
    },
    {
      src: "safeline_logo.png",
      alt: "Safeline",
      url: "https://safelinebrakes.co.za/part-finder/"
    }
  ]

  get productDisplay() {
    return filterTenantDisplay(this.products);
  }

  get totalGbucks() {
    return store.getters['user/totalGbucks']
  }

  get isOwnerUser(): boolean {
    const userClaims = store.getters['user/claims'];
    if (!userClaims) {
      return false;
    }
    return userClaims.has(ApplicationClaimType.ViewClaims) || userClaims.has(ApplicationClaimType.ManageClaims);
  }

  get formattedTotalGbucks(): string {
    return this.totalGbucks.toLocaleString();
  }
}
